export default (location) =>
    location.search
        .replace(/\?/, '')
        .split('&')
        .reduce((acc, next) => {
            const [key, val] = next.split('=');
            acc[key] = val;
            return acc;
        }, {});



/** WEBPACK FOOTER **
 ** ./src/utils/query-parser.js
 **/